// Source: app/scripts/controllers/document-templates.js
Auction.controller('DocumentTemplatesController', [
  '$scope',
  '$upload',
  'Messages',
    '$modal',
    function($scope, $upload, Messages, $modal) {

     var uploadScope = $scope.$new(true);
     // var uploadDialog = Dialogs.modalForm(uploadScope, 'document_templates_upload.html');

      $scope.uploadDialog = $modal({
        scope: uploadScope,
        template: 'forms/document_templates_upload.html',
        show: false
      });

     $scope.afterInit = function (crudScope) {


       var files = [];
       var templateId = null;

       crudScope.uploadDocument = function(dt) {
         templateId = dt.id;
         $scope.uploadDialog.show();
       };

       uploadScope.onFileSelect = function($files) {
         files = $files;
       };

       uploadScope.save = function() {
         var url = '/data/rest/document_templates/upload/'+templateId;
         var success = 0;
           for(var i = 0; i < files.length; i++) {
             var file = files[i];
               $scope.upload = $upload.upload({
                 url: url,
                 file: file
               }).success(function(data, status, headers, config) {
                     success++;
                 if(success == files.length) {
                   Messages.saved();
                   crudScope.reload();
                   $scope.uploadDialog.hide();
                   files = [];
                 } else {
                   Messages.warning("","generic.record_was_not_successfully_saved");
                 }
               });
           }
         }



     };

}]);
